import { render, staticRenderFns } from "./ComplianceMessagingReport.vue?vue&type=template&id=33ef5f42&scoped=true"
import script from "./ComplianceMessagingReport.vue?vue&type=script&lang=js"
export * from "./ComplianceMessagingReport.vue?vue&type=script&lang=js"
import style0 from "./ComplianceMessagingReport.vue?vue&type=style&index=0&id=33ef5f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef5f42",
  null
  
)

export default component.exports